(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'react', '@material-ui/core/Button', '@material-ui/core', '@material-ui/core/ClickAwayListener', '@material-ui/core/Grow', '@material-ui/core/Paper', '@material-ui/core/Popper', '@material-ui/core/MenuList', './SplitButtonMenuItem', './SplitButtonMenu.styles', '../Buttons.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('@material-ui/core/Button'), require('@material-ui/core'), require('@material-ui/core/ClickAwayListener'), require('@material-ui/core/Grow'), require('@material-ui/core/Paper'), require('@material-ui/core/Popper'), require('@material-ui/core/MenuList'), require('./SplitButtonMenuItem'), require('./SplitButtonMenu.styles'), require('../Buttons.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.Button, global.core, global.ClickAwayListener, global.Grow, global.Paper, global.Popper, global.MenuList, global.SplitButtonMenuItem, global.SplitButtonMenu, global.Buttons);
    global.SplitButtonMenu = mod.exports;
  }
})(this, function (exports, _extends2, _objectWithoutProperties2, _react, _Button, _core, _ClickAwayListener, _Grow, _Paper, _Popper, _MenuList, _SplitButtonMenuItem, _SplitButtonMenu, _Buttons) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _react2 = _interopRequireDefault(_react);

  var _Button2 = _interopRequireDefault(_Button);

  var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

  var _Grow2 = _interopRequireDefault(_Grow);

  var _Paper2 = _interopRequireDefault(_Paper);

  var _Popper2 = _interopRequireDefault(_Popper);

  var _MenuList2 = _interopRequireDefault(_MenuList);

  var _SplitButtonMenuItem2 = _interopRequireDefault(_SplitButtonMenuItem);

  var _SplitButtonMenu2 = _interopRequireDefault(_SplitButtonMenu);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SplitButtonMenu = function SplitButtonMenu(_ref) {
    var MenuIcon = _ref.MenuIcon,
        menuItems = _ref.menuItems,
        menuOpen = _ref.menuOpen,
        buttonRef = _ref.buttonRef,
        splitMenuButtonId = _ref.splitMenuButtonId,
        toggleMenuExpanded = _ref.toggleMenuExpanded,
        validateClickAwayListener = _ref.validateClickAwayListener,
        classes = _ref.classes,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['MenuIcon', 'menuItems', 'menuOpen', 'buttonRef', 'splitMenuButtonId', 'toggleMenuExpanded', 'validateClickAwayListener', 'classes', 'disabled']);
    return _react2.default.createElement(
      'div',
      { className: _SplitButtonMenu2.default.menuContainer, 'data-test': 'split-menu' },
      _react2.default.createElement(
        _Button2.default,
        (0, _extends3.default)({
          id: splitMenuButtonId,
          buttonRef: buttonRef,
          onClick: toggleMenuExpanded,
          'aria-owns': menuOpen ? 'menu-list-grow' : undefined,
          'aria-haspopup': 'true',
          'data-test': 'split-menu-button',
          classes: {
            root: classes.root
          },
          className: _SplitButtonMenu2.default.menuButton + ' ' + (disabled ? 'disarm' : ''),
          disabled: disabled
        }, rest),
        _react2.default.createElement(MenuIcon, {
          onClick: toggleMenuExpanded,
          className: _SplitButtonMenu2.default.expandIcon + ' ' + (disabled ? 'disarm' : '')
        })
      ),
      _react2.default.createElement(
        _Popper2.default,
        {
          open: menuOpen,
          anchorEl: buttonRef.current,
          placement: 'bottom-end',
          transition: true,
          disablePortal: true
        },
        function (_ref2) {
          var TransitionProps = _ref2.TransitionProps;
          return _react2.default.createElement(
            _Grow2.default,
            (0, _extends3.default)({}, TransitionProps, { id: 'menu-list-grow' }),
            _react2.default.createElement(
              _Paper2.default,
              { 'data-test': 'split-menu-dropdown' },
              _react2.default.createElement(
                _ClickAwayListener2.default,
                { onClickAway: validateClickAwayListener },
                _react2.default.createElement(
                  _MenuList2.default,
                  null,
                  menuItems.map(function (_ref3) {
                    var label = _ref3.label,
                        clickHandler = _ref3.clickHandler;
                    return _react2.default.createElement(
                      _SplitButtonMenuItem2.default,
                      { clickHandler: clickHandler, key: label },
                      label
                    );
                  })
                )
              )
            )
          );
        }
      )
    );
  };

  exports.default = (0, _core.withStyles)(_Buttons.buttonSecondarySmallStyles)(SplitButtonMenu);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/SplitButton/SplitButtonMenu.js
// module id = 1943
// module chunks = 1